import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import Constants from "../../shared/constants";
import * as Cookies from 'js-cookie';

@Injectable({
    providedIn: 'root'
})
export class OauthQuestionnaireService {
    url = `${environment.AUTH_API}`;

    constructor(
        private http: HttpClient,
    ) {}

    connectQuestionnaire() {
        return this.http.post(`${this.url}oauth/v2/authorize`, {
            'redirect_uri': environment.QUESTIONNAIRE_OAUTH_RET_URL,
            'scope': 'read write',
            'client_id': environment.QUESTIONNAIRE_OAUTH_CLIENT_ID,
            'response_type': 'token',
            'state': 'uniqueCSRFstate'
        },
        {
            headers: new HttpHeaders({
                'X-JWT': `JWT ${sessionStorage.getItem(Constants.AUTH_TOKEN) || Cookies.get(Constants.AUTH_TOKEN)}`
            })
        }).pipe(map(res => res));
    }

    redirect(url: string) {
        location.assign(url);
    }

    setRegionalUrl(region: string) {
        if (region && region.toLowerCase() !== 'au') {
            const originalUrl = environment.AUTH_API;
            const api = originalUrl.slice(0, originalUrl.indexOf('.'));
            const domain = originalUrl.slice(originalUrl.indexOf('.') + 1);

            this.url = `${api}-${region}.${domain}`;

        } else {
            this.url = environment.AUTH_API;
        }
    }
}
